// @ts-ignore
import { spring } from 'vue3-spring';
export const useSpring = (
  val: number,
  springConfig: { stiffness: number; damping: number; mass: number } = {
    stiffness: 400,
    damping: 15,
    mass: 1,
  }
) => {
  const factor = 1000;

  const valueWithFactor = ref<number>(val * factor);

  const effectWithFactor = spring(valueWithFactor, {
    ...springConfig,
    from: val * factor,
  });

  const effect = computed(() => effectWithFactor.value / factor);
  const value = ref<number>(val);
  watch(
    () => value.value,
    (val) => {
      valueWithFactor.value = val * 1000;
    }
  );
  return {
    effect,
    value,
  };
};
